(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    (function(){
  function activateContainer(container, tabKey) {
    var tabs = container.querySelectorAll('.pit-tab');
    var panels = container.querySelectorAll('.pit-panel');
    if (!tabs.length || !panels.length) return;
    tabs.forEach(function(t) {
      var is = t.getAttribute('data-tab') === tabKey;
      t.classList.toggle('pit-tab--active', is);
      t.setAttribute('aria-selected', is ? 'true' : 'false');
    });
    panels.forEach(function(p) {
      p.hidden = p.getAttribute('data-tab') !== tabKey;
    });
  }

  function initAll() {
    document.querySelectorAll('.product-info-tabs').forEach(function(container) {
      var firstTab = container.querySelector('.pit-tab');
      if (!firstTab) return;
      activateContainer(container, firstTab.getAttribute('data-tab'));
    });
  }

  document.addEventListener('click', function(e) {
    var tab = e.target.closest('.pit-tab');
    if (!tab) return;
    var container = tab.closest('.product-info-tabs');
    if (!container) return;
    activateContainer(container, tab.getAttribute('data-tab'));
  }, false);

  document.addEventListener('keydown', function(e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('pit-tab')) return;
    var container = el.closest('.product-info-tabs');
    if (!container) return;
    var tabs = Array.prototype.slice.call(container.querySelectorAll('.pit-tab'));
    var index = tabs.indexOf(el);
    if (e.key === 'ArrowRight') {
      var next = (index + 1) % tabs.length;
      activateContainer(container, tabs[next].getAttribute('data-tab'));
      tabs[next].focus();
      e.preventDefault();
    } else if (e.key === 'ArrowLeft') {
      var prev = (index - 1 + tabs.length) % tabs.length;
      activateContainer(container, tabs[prev].getAttribute('data-tab'));
      tabs[prev].focus();
      e.preventDefault();
    }
  }, false);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
